// extracted by mini-css-extract-plugin
export var callCard = "_pc-0";
export var callMessageButton = "_pc-1";
export var helpIcon = "_pc-3";
export var helpIconContainer = "_pc-4";
export var verticalDivider = "_pc-2";